// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACySURBVHgB7ZNNCsIwEIXfmIKIWLPpz7Jbi3dTT9B6Er2CN/AIXbnxBNKFFRR0EWMSKFgVMcnWbzUzi4/3CAG+ECbT2TjJj5xnHK6EcV4oieTpZA1X/pIO1EqIUKqxEuK+sBEEJJqm3ldGpJPAg9NhR4GJRVhKiQKQFZG0SgTRazo7T/NSJ1M1V3CAtcP1XG8Ho0hXnfeHUXa71BtYwJ4XHxl7PbjK2Kejb803zAPEv/3+BxZ4TlFctqAQAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidePanel_sidePanel__-iqNS {
  position: fixed;
  top: 0;
  right: 0;
  width: 85%;
  height: 100vh;
  background: rgba(249, 249, 249, 1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 30px;
}

.SidePanel_header__ddve9 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.SidePanel_backButton__NbwSw {
    display: flex;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    width: 15px;
    height: 16.2px;
    border: none;
    font-size: 16px;
    cursor: pointer;
}

.SidePanel_backText__hKouU {
    font-weight: bold;
    font-size: 18px;
    padding-left: 20px;
}

.SidePanel_backIcon__z985- {
  margin-right: 8px;
  font-size: 22px;
}

.SidePanel_text__-TagP {
    margin-bottom: 10px;
    color: rgb(108, 106, 106);
}

.SidePanel_title__u2OIV {
  font-size: 16px;
  margin-bottom: 10px;
  color: black;
}

.SidePanel_change__bEk2h {
    color: rgba(29, 135, 82, 1);
}

.SidePanel_content__YNPYP {
    gap: 20px;
    display: flex;
}

.SidePanel_content__YNPYP div {
    width: 200px;
    border-radius: 5px;
    padding: 1.25rem 1.25rem;
    background: white;
}

.SidePanel_secondBlock__pgSa2 .SidePanel_price__YxdWX {
    color: brown;
    font-size: 28px;
}

.SidePanel_thirdBlock__lEJ4v .SidePanel_price__YxdWX {
    font-size: 28px;
    color: blue;
}

.SidePanel_fourthBlock__e80UV .SidePanel_price__YxdWX {
    font-size: 28px;
    color: chocolate;
}

.SidePanel_fifthBlock__rI2cw .SidePanel_price__YxdWX{
    font-size: 28px;
    color: rgba(29, 135, 82, 1);
}

.SidePanel_searchBlock__jpHH6 {
  position: relative;
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
}

.SidePanel_search__yIJdm {
  flex: 1 1;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #ccc;
}

.SidePanel_addProduct__WPVfH,
.SidePanel_endProduct__VY-zT {
  white-space: nowrap;
  padding: 10px 16px;
  font-size: 14px;
  border-radius: 8px;
  border: none;
  color: white;
  cursor: pointer;
}

.SidePanel_addProduct__WPVfH {
  background-color: rgba(29, 135, 82, 1);
}

.SidePanel_endProduct__VY-zT {
  background-color: black;
}

.SidePanel_suggestionList__mxcE8 {
  top: 30px;
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  width: 75.6%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  margin-top: 5px;
  padding: 0;
  list-style: none;
}

.SidePanel_suggestionItem__4UNit {
  padding: 10px;
  cursor: pointer;
}

.SidePanel_suggestionItem__4UNit:hover {
  background-color: #f0f0f0;
}

.SidePanel_productsTable__gnZpC {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.SidePanel_productsTable__gnZpC th,
.SidePanel_productsTable__gnZpC td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.SidePanel_productsTable__gnZpC th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333
}

.SidePanel_productsTable__gnZpC tr:hover {
  background-color: #f5f5f5;
}

.SidePanel_changeNum__-aZsi {
    padding: 5px 0 5px 5px;
    margin-right: 3px;
    border: #333 1px solid;
    background: white;
    border-radius: 3px;
}

.SidePanel_addProductWrap__PR\\+Bk {
  position: relative;
  display: inline-block;
}

.SidePanel_dropdownMenu__g-1ID {
  position: absolute;
  top: 45px;
  right: 0;
  width: 260px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.12);
  padding: 6px 0;
  z-index: 1;
  animation: SidePanel_fadeIn__O8UbK 0.15s ease;
}

@keyframes SidePanel_fadeIn__O8UbK {
  from { opacity: 0; transform: translateY(-5px); }
  to   { opacity: 1; transform: translateY(0); }
}

.SidePanel_dropdownItem__xCdMw {
  padding: 10px 14px;
  cursor: pointer;
}

.SidePanel_dropdownItem__xCdMw:hover {
  background: rgba(29, 135, 82, 0.1);
}

.SidePanel_dropdownItem__xCdMw b {
  font-size: 14px;
  color: #000;
}

.SidePanel_dropdownItem__xCdMw p {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tables/customComponentsTable/SidePanel.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yDAAya;IACza,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,UAAU;EACV,6CAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":[".sidePanel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 85%;\n  height: 100vh;\n  background: rgba(249, 249, 249, 1);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.backButton {\n    display: flex;\n    align-items: center;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACySURBVHgB7ZNNCsIwEIXfmIKIWLPpz7Jbi3dTT9B6Er2CN/AIXbnxBNKFFRR0EWMSKFgVMcnWbzUzi4/3CAG+ECbT2TjJj5xnHK6EcV4oieTpZA1X/pIO1EqIUKqxEuK+sBEEJJqm3ldGpJPAg9NhR4GJRVhKiQKQFZG0SgTRazo7T/NSJ1M1V3CAtcP1XG8Ho0hXnfeHUXa71BtYwJ4XHxl7PbjK2Kejb803zAPEv/3+BxZ4TlFctqAQAAAAAElFTkSuQmCC);\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 15px;\n    height: 16.2px;\n    border: none;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.backText {\n    font-weight: bold;\n    font-size: 18px;\n    padding-left: 20px;\n}\n\n.backIcon {\n  margin-right: 8px;\n  font-size: 22px;\n}\n\n.text {\n    margin-bottom: 10px;\n    color: rgb(108, 106, 106);\n}\n\n.title {\n  font-size: 16px;\n  margin-bottom: 10px;\n  color: black;\n}\n\n.change {\n    color: rgba(29, 135, 82, 1);\n}\n\n.content {\n    gap: 20px;\n    display: flex;\n}\n\n.content div {\n    width: 200px;\n    border-radius: 5px;\n    padding: 1.25rem 1.25rem;\n    background: white;\n}\n\n.secondBlock .price {\n    color: brown;\n    font-size: 28px;\n}\n\n.thirdBlock .price {\n    font-size: 28px;\n    color: blue;\n}\n\n.fourthBlock .price {\n    font-size: 28px;\n    color: chocolate;\n}\n\n.fifthBlock .price{\n    font-size: 28px;\n    color: rgba(29, 135, 82, 1);\n}\n\n.searchBlock {\n  position: relative;\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.search {\n  flex: 1;\n  padding: 10px 15px;\n  font-size: 16px;\n  border-radius: 8px;\n  background: white;\n  border: 1px solid #ccc;\n}\n\n.addProduct,\n.endProduct {\n  white-space: nowrap;\n  padding: 10px 16px;\n  font-size: 14px;\n  border-radius: 8px;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n\n.addProduct {\n  background-color: rgba(29, 135, 82, 1);\n}\n\n.endProduct {\n  background-color: black;\n}\n\n.suggestionList {\n  top: 30px;\n  position: absolute;\n  background: #fff;\n  border: 1px solid #ccc;\n  width: 75.6%;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  margin-top: 5px;\n  padding: 0;\n  list-style: none;\n}\n\n.suggestionItem {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.suggestionItem:hover {\n  background-color: #f0f0f0;\n}\n\n.productsTable {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.productsTable th,\n.productsTable td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.productsTable th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333\n}\n\n.productsTable tr:hover {\n  background-color: #f5f5f5;\n}\n\n.changeNum {\n    padding: 5px 0 5px 5px;\n    margin-right: 3px;\n    border: #333 1px solid;\n    background: white;\n    border-radius: 3px;\n}\n\n.addProductWrap {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdownMenu {\n  position: absolute;\n  top: 45px;\n  right: 0;\n  width: 260px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.12);\n  padding: 6px 0;\n  z-index: 1;\n  animation: fadeIn 0.15s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-5px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.dropdownItem {\n  padding: 10px 14px;\n  cursor: pointer;\n}\n\n.dropdownItem:hover {\n  background: rgba(29, 135, 82, 0.1);\n}\n\n.dropdownItem b {\n  font-size: 14px;\n  color: #000;\n}\n\n.dropdownItem p {\n  font-size: 12px;\n  color: #888;\n  margin-top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidePanel": `SidePanel_sidePanel__-iqNS`,
	"header": `SidePanel_header__ddve9`,
	"backButton": `SidePanel_backButton__NbwSw`,
	"backText": `SidePanel_backText__hKouU`,
	"backIcon": `SidePanel_backIcon__z985-`,
	"text": `SidePanel_text__-TagP`,
	"title": `SidePanel_title__u2OIV`,
	"change": `SidePanel_change__bEk2h`,
	"content": `SidePanel_content__YNPYP`,
	"secondBlock": `SidePanel_secondBlock__pgSa2`,
	"price": `SidePanel_price__YxdWX`,
	"thirdBlock": `SidePanel_thirdBlock__lEJ4v`,
	"fourthBlock": `SidePanel_fourthBlock__e80UV`,
	"fifthBlock": `SidePanel_fifthBlock__rI2cw`,
	"searchBlock": `SidePanel_searchBlock__jpHH6`,
	"search": `SidePanel_search__yIJdm`,
	"addProduct": `SidePanel_addProduct__WPVfH`,
	"endProduct": `SidePanel_endProduct__VY-zT`,
	"suggestionList": `SidePanel_suggestionList__mxcE8`,
	"suggestionItem": `SidePanel_suggestionItem__4UNit`,
	"productsTable": `SidePanel_productsTable__gnZpC`,
	"changeNum": `SidePanel_changeNum__-aZsi`,
	"addProductWrap": `SidePanel_addProductWrap__PR+Bk`,
	"dropdownMenu": `SidePanel_dropdownMenu__g-1ID`,
	"fadeIn": `SidePanel_fadeIn__O8UbK`,
	"dropdownItem": `SidePanel_dropdownItem__xCdMw`
};
export default ___CSS_LOADER_EXPORT___;
